import { render, staticRenderFns } from "./ResearchIndex.vue?vue&type=template&id=2a7fc174&scoped=true"
import script from "./ResearchIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchIndex.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7fc174",
  null
  
)

export default component.exports